import './ProjectBlock.css';
import React from "react";

function ProjectBlock(props) {

    return (
            <p style={{"backgroundColor": props.color}} className={"projectBlockTitle projectBlock" + (props.unstyled ? " " : props.position)}> {props.title}</p>
    )
}

export default ProjectBlock;